import cityActions from './city/actions'
import placeActions from './place/actions'
import addressActions from './address/actions'
import itemActions from './items/actions'
import contactActions from './contact/actions'
import documentActions from './document/actions'
import apiClient from '@u/apiClient'
import GetLatLongFromAddressController from '@/wayfinder/actions/App/Http/Controllers/WikiPlace/GetLatLongFromAddressController'
export default {
  ...cityActions,
  ...placeActions,
  ...addressActions,
  ...itemActions,
  ...contactActions,
  ...documentActions,
  getLatLongFromAddress({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetLatLongFromAddressController.get(), { params: payload })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
